import pageType from 'Addons/search/pageType';
import { mainConfig } from 'Models/uiConfig/componentlessWidgetsConfig';
import defaultProductConfig from 'Platforms/bigcommerce/productConfig';

import type { ProductConfig, ProductFieldMap } from './productConfig.types';
import uiConfig from './uiConfig';

const productRuntimeConfig = mainConfig.product ?? {};
const { getItemId: getItemIdCustom, priceFormatter: priceFormatterCustom, ...config } = productRuntimeConfig;

const commonFields = ['id', 'image', 'title', 'url'];

const defaultFields = commonFields.reduce<ProductFieldMap>((fields, name) => {
  fields[name] = {
    toString: () => {
      console.error(`${name} field is missing in productConfig`);
      return '';
    },
  };
  return fields;
}, {});

const {
  getItemId: getItemIdDefault,
  priceFormatter: priceFormatterDefault,
  ...defaults
} = defaultProductConfig;

/* eslint-disable camelcase */
const brandFields = {
  brand_name: 'brand_name',
  vendor: 'vendor',
  brand: 'brand',
  Brand: 'Brand',
};
/* eslint-enable camelcase */

const fields: ProductFieldMap = {
  key: '_docid',
  ...(defaults.fields || defaultFields),
  ...brandFields,
  ...(config.fields && typeof config.fields === 'object' ? config.fields : {}),
};

const localItemId =
  uiConfig.pageType === pageType.product
    ? getItemIdCustom
      ? getItemIdCustom({
          getItemId: getItemIdDefault,
          getVariantId: defaults.getVariantId,
        })
      : (getItemIdDefault?.() ?? '')
    : '';

function isNumberFormat(value: unknown): value is Intl.NumberFormat {
  return value instanceof Intl.NumberFormat;
}

// create new function instead of passing priceFormatter.format itself
// to prevent bugs if format() would depend on this
const priceFormatter = isNumberFormat(priceFormatterCustom)
  ? priceFormatterCustom
  : isNumberFormat(priceFormatterDefault)
    ? priceFormatterDefault
    : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
const formatPrice = (price: number | null | undefined): string => (price ? priceFormatter.format(price) : '');

const productConfig: ProductConfig = {
  localItemId,
  entityIdField: 'id',
  formatPrice,
  noImageSrc: 'https://client.convermax.com/static/img/noimage.png',
  ...defaults,
  ...config,
  fields,
};

window.Convermax.templates!.config.productConfig = productConfig;
export default productConfig;
